import { Button } from "@/components/ui/button";
export default function HeroSplit() {
  return <section data-section-id="256034" id="program-overview" className="w-full bg-background text-foreground">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[75vh] lg:min-h-[85vh]">
        {/* Content Column */}
        <div className="flex flex-col justify-center items-start px-8 py-20 border-r-0 border-primary/30 !bg-[hsl(0,0%,0%)] md:px-16 lg:px-24 xl:px-32 lg:border-r">
          <span className="font-default text-xs md:text-sm tracking-[0.2em] uppercase mb-6 text-primary font-bold">
            Exclusief Voordeel
          </span>
          <h1 className="font-default leading-[1.1] mb-6 font-bold uppercase !text-[hsl(347,77%,50%)] !text-3xl">HET CRIMSON EDGE
SPAARSYSTEEM</h1>
          <p className="font-sans text-base md:text-lg text-muted-foreground mb-10 max-w-md">
            Bij elke knipbeurt spaar je automatisch 1 punt. Wij belonen onze trouwe klanten en maken topkwaliteit haarverzorging betaalbaar voor het hele gezin.
          </p>
          
        </div>

        {/* Image Column */}
        <div className="relative w-full h-[60vh] lg:h-auto overflow-hidden">
          <img src="https://literate-katydid.10web.cloud/wp-content/uploads/2026/05/crimson_edge_shears.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577285/img/crimson_edge_shears.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1577285/img/crimson_edge_shears.png-wvc-sizes" alt="Desaturated barber shears with a subtle crimson red glow on the blade" className="absolute inset-0 w-full h-full object-cover grayscale contrast-125" />
          <div className="absolute inset-0 bg-gradient-to-t from-background/40 to-transparent pointer-events-none" />
          <div className="absolute inset-0 bg-primary/5 mix-blend-overlay pointer-events-none" />
        </div>
      </div>
    </section>;
}